module.exports = __webpack_public_path__ + "static/media/codec.0c481e87.mp3";